import { useParams } from 'react-router'

import { CatalogList } from 'layout-components/general/data-connections/catalog-list'
import { useFetchConnectedSourceSystem } from 'layout-components/general/data-connections/queries/fetch-connected-source-system'
import { DataConnectionMode } from 'layout-components/general/data-connections/types'

export function CatalogTab({ mode }: { mode: DataConnectionMode }) {
  const { id } = useParams<{ id: string }>()
  const { isPending, data } = useFetchConnectedSourceSystem({ id })

  return <CatalogList mode={mode} isPending={isPending} connectedSourceSystem={data} />
}
